import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Grid from '@material-ui/core/Grid';
import { useStyles } from './TakisSkeleton.styles';

const TakisRecipeListSkeleton = ({totalRecipes = 6, hideLoadMore}) => {
  const classes = useStyles();

  const getPlaceholderItems = () => {
    let  recipeitems = []
    for (let i = 0; i < totalRecipes; i ++) {
      recipeitems.push(
        <Grid className={classes.takisRecipeListItemContainer} key={i} container item sx={12} lg={6}>
          <Skeleton className={classes.takisRecipeListItem}/>
        </Grid>
      )
    }
    return recipeitems
  }

  return (
    <>
      <div className={`${classes.takisRecipeList}`}>
        <Skeleton variant="rect" className={classes.takisRecipeHeading}/>
        <Grid className={classes.takisRecipeListContainer} container justifyContent="center" spacing={4}>
          {getPlaceholderItems()}
          {
            !hideLoadMore &&
            <Skeleton variant="rect" className={classes.takisRecipeButton}/>
          }
        </Grid>
      </div>
    </>
  );
}

export default TakisRecipeListSkeleton;
